import Axios from 'axios';

function extractApiUrlFromBodyOrSameDomain() {
	let baseURL = document.body.getAttribute('api-url');

	if (!baseURL) {
		let segs = document.location.hostname.split('.');
		segs = segs.splice(segs.length - 2);
		segs.unshift('api');
		baseURL = document.location.protocol + '//' + segs.join('.');
	}
	
	return baseURL;
}

const baseURL = extractApiUrlFromBodyOrSameDomain();

export const api = Axios.create({
  baseURL: baseURL + '/dashboard',
});

export default function setupAxios(store) {
  api.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      config.headers['Access-Control-Allow-Origin'] = '*';
      config.headers['Content-Type'] = 'application/json';

      return config;
    },
    (err) => Promise.reject(err)
  );
}